/**
 * The Quote record's projected fields: written from the quote engine on every sync, so an
 * edit in the record form would be overwritten. Mirrors `QUOTE_FIELDS` (+ `customer`) in
 * backend/src/matic/quoting/agent_capabilities/quote_record.py — keep the two in step. The
 * record's owned fields are not here; see `QUOTE_PROGRESS_FIELD_KEYS` for the ones that are
 * still locked.
 */
export const QUOTE_MODULE_TAG = 'quoting:quote';

export const QUOTE_DESK_FIELD_KEYS: readonly string[] = [
  'request_id',
  'subject',
  'status',
  'customer',
  'customer_group',
  'engine',
  'rating_kw',
  'grade',
  'silencer_class',
  'part_number',
  'silencer_sell',
  'package_sell',
  'as_of',
  'received',
  'exportable',
  'open_decisions',
  'flags',
  'relay_thread_id',
];

/**
 * The quote's progress and its stamps (who set it, and when). Owned by MATIC, but changed only
 * through the quote workspace (Mark done / Decline / Reopen), which stamps every change. A
 * record-form edit would skip the stamp, so these are read-only there. ERP quote number,
 * assignee and waiting on stay editable anywhere.
 */
export const QUOTE_PROGRESS_FIELD_KEYS: readonly string[] = [
  'progress',
  'progress_source',
  'progress_at',
];
